import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { globalTheme } from '@clds/component-theme';
import { Typography } from '@clds/typography';
import { Button } from '@clds/button';
import { ModalLayout, ModalNext } from '@clds/modal';
import { messages } from '../../i18n';

export interface StrictTransformationsModalProps {
  isOpen: boolean;
  isEnabled: boolean;
  onClose: () => void;
  onConfirm: (enable: boolean) => void;
}

const CancelButton = styled(Button)`
  margin-right: ${globalTheme.spacing.sm};
`;

const Footer = styled.div`
  display: flex;
  justify-content: right;
  width: 100%;
`;

const WidthLimiter = styled.div`
  max-width: 480px;
`;

export const StrictTransformationsModal: FC<React.PropsWithChildren<StrictTransformationsModalProps>> = ({ isOpen, isEnabled, onClose, onConfirm }) => (
  <ModalNext isOpen={isOpen} onClose={onClose}>
    <WidthLimiter>
      <ModalLayout
        closeIcon
        header={
          <Typography size="lg" type="regular">
            <FormattedMessage {...messages.strictTransformationsModalHeader} />
          </Typography>
        }
        footer={
          <Footer>
            <CancelButton onClick={onClose} variant="secondary">
              <FormattedMessage {...messages.strictTransformationsModalCancel} />
            </CancelButton>

            <Button
              onClick={() => {
                onConfirm(!isEnabled);
                onClose();
              }}
              variant={isEnabled ? 'error' : 'primary'}
              data-test-specifier="switchConfirmationButton"
            >
              {isEnabled ? (
                <FormattedMessage {...messages.strictTransformationsDisableConfirm} />
              ) : (
                <FormattedMessage {...messages.strictTransformationsEnableConfirm} />
              )}
            </Button>
          </Footer>
        }
      >
        <Typography size="sm" type="regular">
          {isEnabled ? (
            <FormattedMessage {...messages.strictTransformationsModalDisableContent} />
          ) : (
            <FormattedMessage {...messages.strictTransformationsModalEnableContent} />
          )}
        </Typography>
      </ModalLayout>
    </WidthLimiter>
  </ModalNext>
);
